import { TFunction } from 'i18next';

export const BASKET_STATUS_GROUPS_DISABLE_DEFAULT = ['INACTIVE'];

export type BasketStatusGroup = {
  id: string;
  name: string;
  color: BasketStatusGroupColor;
  additionalInfo?: string;
};

export type BasketStatusGroupColor = {
  bg: string;
  text: string;
};

export const getBasketStatusGroupsAdditionalInfo = (
  t: TFunction,
): Record<string, { additionalInfo: string }> => ({
  NEGOTIATING: {
    additionalInfo: t(
      'basketStatusGroups.negotiating.additionalInfo',
      'Negocjacje transakcji\nNegocjacje zleceń\nNegocjacje transakcji zakończone',
    ),
  },
  INACTIVE: {
    additionalInfo: t(
      'basketStatusGroups.inactive.additionalInfo',
      'Wstrzymane\nUsunięte',
    ),
  },
});
